// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingWrapper {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  margin-top: 20px;
}
.LoadingWrapper .tableLine {
  display: grid;
  grid-template-columns: 26px minmax(0, 1.2fr);
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  padding: 0px 12px 0px 8px;
}
.LoadingWrapper .tableLine .skeletons {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}
.LoadingWrapper .tableLine > :nth-child(n+3) {
  justify-self: end;
}`, "",{"version":3,"sources":["webpack://./src/components/SkeletonTable/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,4CAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;AACJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AACN;AAEI;EACE,iBAAA;AAAN","sourcesContent":[".LoadingWrapper {\n  display: flex;\n  flex-direction: column;\n  row-gap: 40px;\n  margin-top: 20px;\n\n  .tableLine {\n    display: grid;\n    grid-template-columns: 26px minmax(0, 1.2fr);\n    grid-auto-flow: column;\n    grid-auto-columns: 1fr;\n    padding: 0px 12px 0px 8px;\n\n    .skeletons {\n      display: flex;\n      flex-direction: column;\n      row-gap: 40px;\n    }\n\n    & > :nth-child(n + 3) {\n      justify-self: end;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
